import { IxMenuItem } from './IxMenuItem.js';

window.customElements.define('ix-menu-item', IxMenuItem);
